import styled from 'styled-components'
import { Cancel } from '@mui/icons-material'

interface Props {
  imageUrl: string
  disabled?: boolean
  circularImage: boolean
  deleteFile?: () => void
}

export default function UploadedImage({ imageUrl, disabled = false, circularImage, deleteFile }: Props): JSX.Element {
  return (
    <ImageContainer>
      {imageUrl && (
        <>
          {circularImage ? <CircularImage src={imageUrl} /> : <Image src={imageUrl} />}
          {!disabled && deleteFile && <RemoveImageIcon onClick={deleteFile} />}
        </>
      )}
    </ImageContainer>
  )
}

const ImageContainer = styled.div`
  position: relative;
  margin-top: 10px;
  max-width: 300px;
`

const Image = styled.img`
  border: 1px dashed;
  padding: 5px;
  border-color: ${(props) => props.theme.customPalette.mediumGray};
  max-height: 100px;
  max-width: 100%;
  position: relative;
`

const CircularImage = styled(Image)`
  border-radius: 50%;
`

const RemoveImageIcon = styled(Cancel)`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 99999;
  color: #000;
  cursor: pointer;
  background-color: #fff;
  border-radius: 50%;
`
